import React, { useContext, useState } from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import { IoMdMail } from "react-icons/io";
import { BsFillTelephoneFill } from "react-icons/bs";
import SideNav from "./SideNav";
import { MyContext } from "../context/context";
import { Link } from "react-router-dom";
import { GrFormClose } from "react-icons/gr";

const Navbar = ({ pricing }) => {
  const [open, setOpen] = useState(false);
  const { language, setLanguage } = useContext(MyContext);
  const { languageData } = useContext(MyContext);

  const scrollToPage = (id) => {
    const page = document.getElementById(id);
    page.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="shadow-md w-full text-[0.9rem] md:text-[1rem]">
      <div className="bg-yellow-400">
        <div className="flex items-center justify-between max-w-6xl mx-auto md:space-x-2">
          <div className="p-1 px-2 transform bg-gray-900 w-max md:flex md:space-x-4">
            <div className="flex items-center py-1 space-x-1">
              <IoMdMail className="text-yellow-400" />
              <a
                className="text-white underline"
                href="mailto:narucitetaxi@tuzlataxi.com"
              >
                narucitetaxi@tuzlataxi.com
              </a>
            </div>

            <div className="flex items-center mx-auto space-x-1">
              <BsFillTelephoneFill className="text-yellow-400" />
              <a href="tel:+38762979333" className="text-white underline">
                +387 62 979 333
              </a>
            </div>
          </div>

          {/* <div className="bg-gray-900 w-[0.9rem]"></div> */}

          <div className="flex items-center space-x-2">
            <img
              src={
                language === "Bosnian" ? "/images/bosnia.png" : "/images/US.png"
              }
              alt=""
              className="hidden md:block md:w-[1.5rem] md:h-[1.2rem]"
            />
            <select
              value={language}
              onChange={(e) => {
                setLanguage(e.target.value);
                localStorage.setItem("lang", JSON.stringify(e.target.value));
              }}
              className="text-white h-[2.44rem] px-1 bg-gray-900 outline-none w-max"
            >
              <option value="Bosnian">BiH</option>
              <option value="English">EN/US</option>
            </select>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-between max-w-6xl py-2 mx-5 lg:px-0 lg:mx-auto">
        <Link to="/">
          <img
            src="/images/logo.png"
            alt=""
            className="w-[3rem] h-[3rem] md:h-[4.6rem] md:w-[4.5rem]"
          />
        </Link>

        {!pricing && (
          <button
            className="md:hidden"
            onClick={() => setOpen((prev) => !prev)}
          >
            {!open ? <GiHamburgerMenu size={25} /> : <GrFormClose size={35} />}
          </button>
        )}

        {!pricing && (
          <div className="hidden font-bold md:flex space-x-7">
            <span
              onClick={() => scrollToPage("hero")}
              className="cursor-pointer hover:text-yellow-500"
            >
              {languageData?.navFirstItem}
            </span>
            <span
              onClick={() => scrollToPage("about")}
              className="cursor-pointer hover:text-yellow-500"
            >
              {languageData?.navSecondItem}
            </span>
            <Link to="/cjenovnik">
              <span className="cursor-pointer hover:text-yellow-500">
                {languageData?.navThirdItem}
              </span>
            </Link>
            <span
              onClick={() => scrollToPage("contact")}
              className="cursor-pointer hover:text-yellow-500"
            >
              {languageData?.navFourthItem}
            </span>
          </div>
        )}

        {pricing && (
          <div className="flex items-center space-x-5">
            <span
              onClick={() => scrollToPage("contact")}
              className="font-bold cursor-pointer hover:text-yellow-500"
            >
              {languageData?.navFourthItem}
            </span>
            <Link to="/">
              <button className="p-2 font-bold duration-300 bg-yellow-400 border border-black hover:bg-gray-900 hover:text-white">
                {languageData?.pricingButton}
              </button>
            </Link>
          </div>
        )}
      </div>

      <div className="relative">
        {open && (
          <SideNav setOpen={setOpen} open={open} scrollToPage={scrollToPage} />
        )}
      </div>
    </div>
  );
};

export default Navbar;
